import { apiRequest } from "../util/apiUtils";

export const subsciptionList = async (params) => {
  try {
    const res = await apiRequest("get", "subscription/list", {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const mySubscriptionList = async (params) => {
  try {
    const res = await apiRequest("get", "subscription/my-subsciption", {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const subsciptionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `subscription/master-cancel-sub`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const donorSubsciptionStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `/subscription/user-cancel-sub`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
